var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardBugados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1203,
    height: 677,
    viewBox: "0 0 1203 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1181.7 1H21.14C10.0943 1 1.14001 9.9543 1.14001 21V655.69C1.14001 666.736 10.0943 675.69 21.14 675.69H1181.7C1192.75 675.69 1201.7 666.736 1201.7 655.69V21C1201.7 9.9543 1192.75 1 1181.7 1Z",
    fill: "url(#paint0_linear_1_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.7 1H21.14C10.0943 1 1.14001 9.9543 1.14001 21V655.69C1.14001 666.736 10.0943 675.69 21.14 675.69H1181.7C1192.75 675.69 1201.7 666.736 1201.7 655.69V21C1201.7 9.9543 1192.75 1 1181.7 1Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.06 676V587.21H985.66",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.89 675.69L1090.71 520.93V490.29",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.89 551.57H1039.44V538.7",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.39 396.14L925.01 395.87",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M810.04 676V551.57",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M811.04 632H888.22",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M855.35 634.09V503.32",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M997.63 395.87V473.32",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.7 490.29H1144.48V545.14",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.11 395.87L1108.84 242.05",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.84 263.22H997.63",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M925.01 675.69L925.61 538.7",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.23 1.31V140.1",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.23 101.78L1044.9 101.87",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M997.54 477.79C999.959 477.79 1001.92 475.829 1001.92 473.41C1001.92 470.991 999.959 469.03 997.54 469.03C995.121 469.03 993.16 470.991 993.16 473.41C993.16 475.829 995.121 477.79 997.54 477.79Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.44 542.82C1041.86 542.82 1043.82 540.859 1043.82 538.44C1043.82 536.021 1041.86 534.06 1039.44 534.06C1037.02 534.06 1035.06 536.021 1035.06 538.44C1035.06 540.859 1037.02 542.82 1039.44 542.82Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.71 494.67C1093.13 494.67 1095.09 492.709 1095.09 490.29C1095.09 487.871 1093.13 485.91 1090.71 485.91C1088.29 485.91 1086.33 487.871 1086.33 490.29C1086.33 492.709 1088.29 494.67 1090.71 494.67Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.48 549.69C1146.9 549.69 1148.86 547.729 1148.86 545.31C1148.86 542.891 1146.9 540.93 1144.48 540.93C1142.06 540.93 1140.1 542.891 1140.1 545.31C1140.1 547.729 1142.06 549.69 1144.48 549.69Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M982.53 591.59C984.949 591.59 986.91 589.629 986.91 587.21C986.91 584.791 984.949 582.83 982.53 582.83C980.111 582.83 978.15 584.791 978.15 587.21C978.15 589.629 980.111 591.59 982.53 591.59Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M925.01 542.82C927.429 542.82 929.39 540.859 929.39 538.44C929.39 536.021 927.429 534.06 925.01 534.06C922.591 534.06 920.63 536.021 920.63 538.44C920.63 540.859 922.591 542.82 925.01 542.82Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M925.01 400.25C927.429 400.25 929.39 398.289 929.39 395.87C929.39 393.451 927.429 391.49 925.01 391.49C922.591 391.49 920.63 393.451 920.63 395.87C920.63 398.289 922.591 400.25 925.01 400.25Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M855.35 504.29C857.769 504.29 859.73 502.329 859.73 499.91C859.73 497.491 857.769 495.53 855.35 495.53C852.931 495.53 850.97 497.491 850.97 499.91C850.97 502.329 852.931 504.29 855.35 504.29Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M888.49 636.47C890.909 636.47 892.87 634.509 892.87 632.09C892.87 629.671 890.909 627.71 888.49 627.71C886.071 627.71 884.11 629.671 884.11 632.09C884.11 634.509 886.071 636.47 888.49 636.47Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M809.95 555.95C812.369 555.95 814.33 553.989 814.33 551.57C814.33 549.151 812.369 547.19 809.95 547.19C807.531 547.19 805.57 549.151 805.57 551.57C805.57 553.989 807.531 555.95 809.95 555.95Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M997.54 267.69C999.959 267.69 1001.92 265.729 1001.92 263.31C1001.92 260.891 999.959 258.93 997.54 258.93C995.121 258.93 993.16 260.891 993.16 263.31C993.16 265.729 995.121 267.69 997.54 267.69Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.84 242.05C1111.26 242.05 1113.22 240.089 1113.22 237.67C1113.22 235.251 1111.26 233.29 1108.84 233.29C1106.42 233.29 1104.46 235.251 1104.46 237.67C1104.46 240.089 1106.42 242.05 1108.84 242.05Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.9 106.47C1047.32 106.47 1049.28 104.509 1049.28 102.09C1049.28 99.671 1047.32 97.71 1044.9 97.71C1042.48 97.71 1040.52 99.671 1040.52 102.09C1040.52 104.509 1042.48 106.47 1044.9 106.47Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.41 144.66C1136.83 144.66 1138.79 142.699 1138.79 140.28C1138.79 137.861 1136.83 135.9 1134.41 135.9C1131.99 135.9 1130.03 137.861 1130.03 140.28C1130.03 142.699 1131.99 144.66 1134.41 144.66Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.11 323.65L1015.36 323.54",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.68 328.34C1018.1 328.34 1020.06 326.379 1020.06 323.96C1020.06 321.541 1018.1 319.58 1015.68 319.58C1013.26 319.58 1011.3 321.541 1011.3 323.96C1011.3 326.379 1013.26 328.34 1015.68 328.34Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.39 193.75H962",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M962.53 198.28C964.949 198.28 966.91 196.319 966.91 193.9C966.91 191.481 964.949 189.52 962.53 189.52C960.111 189.52 958.15 191.481 958.15 193.9C958.15 196.319 960.111 198.28 962.53 198.28Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.09 193.54V303.95",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.25 308.33C1175.67 308.33 1177.63 306.369 1177.63 303.95C1177.63 301.531 1175.67 299.57 1173.25 299.57C1170.83 299.57 1168.87 301.531 1168.87 303.95C1168.87 306.369 1170.83 308.33 1173.25 308.33Z",
    fill: "white",
    stroke: "#FCC50B",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5",
    x1: 1.14001,
    y1: 338.34,
    x2: 1201.7,
    y2: 338.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBugados);
export default __webpack_public_path__ + "static/media/CardBugados.23bbb7a1a71df43c9da8abcd25495fdc.svg";
export { ForwardRef as ReactComponent };